import React from 'react';
import { FaChevronLeft, FaFire, FaSignOutAlt } from 'react-icons/fa';
import {
  Header,
  HeaderBackButton,
  HeaderTitle,
  HeaderTitleGroup,
  HeaderTitleIcon,
  LogoutContext
} from '../styles';

interface PwaHeaderProps {
  onBack?: () => void;
  onLogout?: () => void;
  title?: string;
}

const PwaHeader: React.FC<PwaHeaderProps> = ({ onBack, onLogout, title = 'Seguro Incêndio' }) => (
  <Header>
    <HeaderTitleGroup>
      {onBack && (
        <HeaderBackButton type="button" onClick={onBack} aria-label="Voltar" title="Voltar">
          <FaChevronLeft />
        </HeaderBackButton>
      )}
      <HeaderTitleIcon>
        <FaFire />
      </HeaderTitleIcon>
      <HeaderTitle>{title}</HeaderTitle>
    </HeaderTitleGroup>
    {onLogout && (
      <LogoutContext type="button" onClick={onLogout} aria-label="Sair" title="Sair">
        <FaSignOutAlt aria-hidden="true" />
      </LogoutContext>
    )}
  </Header>
);

export default PwaHeader;
